import dayjs from 'dayjs';

/** The only date-as-string format exchanged with the API and compared/sorted client-side. */
export const DATE_FORMAT: string = 'YYYY-MM-DD';

/** French rendering, for display only. Never send this to the API. */
export const DISPLAY_DATE_FORMAT: string = 'DD/MM/YYYY';

export function getNextWeekMonday(): dayjs.Dayjs {
    return dayjs().startOf('week').add(7, 'days');
}

export interface WeekdayInfo {
    value: string;
    name: string;
}

export const WEEKDAY_INFO: WeekdayInfo[] = [
    { value: 'monday', name: 'lundi' },
    { value: 'tuesday', name: 'mardi' },
    { value: 'wednesday', name: 'mercredi' },
    { value: 'thursday', name: 'jeudi' },
    { value: 'friday', name: 'vendredi' },
];

export const DAYS_OF_THE_WEEK: string[] = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
];

/** Renders a `YYYY-MM-DD` date as `DD/MM/YYYY`, for display only. */
export function formatDateForDisplay(date: string): string {
    return dayjs(date, DATE_FORMAT).format(DISPLAY_DATE_FORMAT);
}
